module.exports = __webpack_public_path__ + "img/mirror_circle.2b52a67d.png";